var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"mt-10 text-center grey--text"},[_c('v-icon',{attrs:{"color":"grey lighten-1","size":"64"}},[_vm._v(" mdi-snake ")]),_c('p',[_vm._v("Список данных пуст")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }